/* eslint-disable max-lines */
import { useI18n, formatCurrency } from '@popety_io/popety-io-lib'
import { Box, Typography, Grid } from '@mui/material'
import Paper from '@mui/material/Paper'

import MouseHoverPopover from '../../../../components/MouseHoverPopover'

const PotetialSolaireSection = ({
  data,
  solarAverage,
  solarAverageColor,
}: {
  data: any
  solarAverage: any
  solarAverageColor: any
}) => {
  const { t } = useI18n()

  return (
    <Box paddingY={2} display="flex" flexDirection="column" gap={4}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: '4px',
            fontSize: '1.1rem',
            textTransform: 'uppercase',
          }}
        >
          {t('building.energy.Potential Solaire toiture')}
        </Typography>
      </Box>
      <Grid container spacing={{ xs: 1, sm: 3 }} alignItems="flex-start">
        <Grid item container xs={12} sm={6} md={4}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
              flexGrow: 1,
            }}
          >
            <Typography
              color={solarAverageColor as string}
              variant="h5"
              fontSize="1.846rem"
              fontWeight="500"
            >
              {solarAverage || 'N/A'}
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="center">
              <MouseHoverPopover
                title={t('common.Aptitude Solaire')}
                sx={{ display: 'flex', gap: 1 }}
              >
                <Paper
                  sx={{
                    padding: 2,
                    width: 'fit-content',
                    maxWidth: '600px',
                    'div > span': {
                      padding: '3px',
                    },
                  }}
                >
                  <Box
                    gap="2px"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography component="span" color="text.secondary">
                      {t('land.sunlight.aptitudeSolaire-desc1')}
                    </Typography>
                    <Typography component="span" color="text.secondary">
                      {t('land.sunlight.aptitudeSolaire-desc2')}
                    </Typography>
                    <Typography component="span" color="text.secondary">
                      {t('land.sunlight.aptitudeSolaire-desc-weak')}
                    </Typography>
                    <Typography component="span" color="text.secondary">
                      {t('land.sunlight.aptitudeSolaire-desc-mid')}
                    </Typography>
                    <Typography component="span" color="text.secondary">
                      {t('land.sunlight.aptitudeSolaire-desc-good')}
                    </Typography>
                    <Typography component="span" color="text.secondary">
                      {t('land.sunlight.aptitudeSolaire-desc-very-good')}
                    </Typography>
                    <Typography component="span" color="text.secondary">
                      {t('land.sunlight.aptitudeSolaire-desc-excellent')}
                    </Typography>
                  </Box>
                </Paper>
              </MouseHoverPopover>
            </Box>
          </Box>
        </Grid>
        <Grid item container xs={12} sm={6} md={4}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
              flexGrow: 1,
            }}
          >
            <Typography variant="h5" fontSize="1.846rem" fontWeight="500">
              {!data?.average_exposure
                ? 'N/A'
                : `${formatCurrency(data?.average_exposure || 0, '')} kWh/m2`}
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="center">
              <MouseHoverPopover
                title={t('land.sun.Exposition moyenne')}
                sx={{ display: 'flex', gap: 1 }}
              >
                <Paper
                  sx={{
                    padding: 2,
                    width: 'fit-content',
                    maxWidth: '600px',
                    'div > span': {
                      padding: '3px',
                    },
                  }}
                >
                  <Box
                    gap="2px"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography component="span" color="text.secondary">
                      {t('land.sunlight.expositionMoyenne-desc')}
                    </Typography>
                  </Box>
                </Paper>
              </MouseHoverPopover>
            </Box>
          </Box>
        </Grid>
        <Grid item container xs={12} sm={6} md={4}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
              flexGrow: 1,
            }}
          >
            <Typography variant="h5" fontSize="1.846rem" fontWeight="500">
              {!data?.roof_area
                ? 'N/A'
                : `${formatCurrency(data?.roof_area || 0, '')} m2`}
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="center">
              <MouseHoverPopover
                title={t('land.sun.Surface toits')}
                sx={{ display: 'flex', gap: 1 }}
              >
                <Paper
                  sx={{
                    padding: 2,
                    width: 'fit-content',
                    maxWidth: '600px',
                    'div > span': {
                      padding: '3px',
                    },
                  }}
                >
                  <Box
                    gap="2px"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography component="span" color="text.secondary">
                      {t('land.sunlight.Surface toits-desc')}
                    </Typography>
                  </Box>
                </Paper>
              </MouseHoverPopover>
            </Box>
          </Box>
        </Grid>
        <Grid item container xs={12} sm={6} md={4}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
              flexGrow: 1,
            }}
          >
            <Typography variant="h5" fontSize="1.846rem" fontWeight="500">
              {!data?.global_exposure
                ? 'N/A'
                : `${formatCurrency(data?.global_exposure || 0, '')} kWh`}
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="center">
              <MouseHoverPopover
                title={t('land.sun.Exposition globale')}
                sx={{ display: 'flex', gap: 1 }}
              >
                <Paper
                  sx={{
                    padding: 2,
                    width: 'fit-content',
                    maxWidth: '600px',
                    'div > span': {
                      padding: '3px',
                    },
                  }}
                >
                  <Box
                    gap="2px"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography component="span" color="text.secondary">
                      {t('land.sun.Exposition globale-desc')}
                    </Typography>
                  </Box>
                </Paper>
              </MouseHoverPopover>
            </Box>
          </Box>
        </Grid>
        <Grid item container xs={12} sm={6} md={4}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
              flexGrow: 1,
            }}
          >
            <Typography variant="h5" fontSize="1.846rem" fontWeight="500">
              {!data?.electrical_efficiency
                ? 'N/A'
                : `${formatCurrency(data?.electrical_efficiency || 0, '')} kWh`}
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="center">
              <MouseHoverPopover
                title={`${t('land.sun.Rendement électrique')}`}
                sx={{ display: 'flex', gap: 1, textAlign: 'center' }}
              >
                <Paper
                  sx={{
                    padding: 2,
                    width: 'fit-content',
                    maxWidth: '600px',
                    'div > span': {
                      padding: '3px',
                    },
                  }}
                >
                  <Box
                    gap="2px"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography component="span" color="text.secondary">
                      {t('land.sun.Rendement électrique-desc').replace(
                        /(;|:)/g,
                        '$1\n',
                      )}
                    </Typography>
                  </Box>
                </Paper>
              </MouseHoverPopover>
            </Box>
          </Box>
        </Grid>
        <Grid item container xs={12} sm={6} md={4}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
              flexGrow: 1,
            }}
          >
            <Typography variant="h5" fontSize="1.846rem" fontWeight="500">
              {!data?.thermal_efficiency
                ? 'N/A'
                : `${formatCurrency(data?.thermal_efficiency || 0, '')} kWh`}
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="center">
              <MouseHoverPopover
                title={t('land.sun.Rendement thermique')}
                sx={{ display: 'flex', gap: 1 }}
              >
                <Paper
                  sx={{
                    padding: 2,
                    width: 'fit-content',
                    maxWidth: '600px',
                    'div > span': {
                      padding: '3px',
                    },
                  }}
                >
                  <Box
                    gap="2px"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography component="span" color="text.secondary">
                      {t('land.sun.Rendement thermique-desc').replace(
                        /(;|:)/g,
                        '$1\n',
                      )}
                    </Typography>
                  </Box>
                </Paper>
              </MouseHoverPopover>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default PotetialSolaireSection
